import React, { Component, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import * as d3 from 'd3-selection';

function Container(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n          .configContainer {\n              display: grid;\n              grid-template-columns: 1fr;\n              grid-template-rows: ".concat(props.headerHeight, " ").concat(props.bodyHeight, " ").concat(props.footerHeight, ";\n              padding: 0px;\n          }\n        ")), /*#__PURE__*/React.createElement("div", {
    className: "configContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, props.header), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, props.body), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, props.footer)));
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

var Step = /*#__PURE__*/function (_Component) {
  _inherits(Step, _Component);
  var _super = _createSuper(Step);
  function Step() {
    var _this;
    _classCallCheck(this, Step);
    _this = _super.call(this);
    _this.getStyles = _this.getStyles.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Step, [{
    key: "getStyles",
    value: function getStyles() {
      var _this$props = this.props,
        activeColor = _this$props.activeColor,
        completeColor = _this$props.completeColor,
        defaultColor = _this$props.defaultColor,
        circleFontColor = _this$props.circleFontColor;
        _this$props.activeTitleColor;
        var completeTitleColor = _this$props.completeTitleColor;
        _this$props.defaultTitleColor;
        var size = _this$props.size,
        circleFontSize = _this$props.circleFontSize,
        titleFontSize = _this$props.titleFontSize,
        circleTop = _this$props.circleTop,
        titleTop = _this$props.titleTop,
        width = _this$props.width,
        completeOpacity = _this$props.completeOpacity,
        activeOpacity = _this$props.activeOpacity,
        defaultOpacity = _this$props.defaultOpacity,
        completeTitleOpacity = _this$props.completeTitleOpacity;
        _this$props.activeTitleOpacity;
        _this$props.defaultTitleOpacity;
        var barStyle = _this$props.barStyle,
        defaultBarColor = _this$props.defaultBarColor,
        completeBarColor = _this$props.completeBarColor,
        defaultBorderColor = _this$props.defaultBorderColor,
        completeBorderColor = _this$props.completeBorderColor,
        activeBorderColor = _this$props.activeBorderColor,
        defaultBorderStyle = _this$props.defaultBorderStyle,
        completeBorderStyle = _this$props.completeBorderStyle,
        activeBorderStyle = _this$props.activeBorderStyle,
        lineMarginOffset = _this$props.lineMarginOffset,
        defaultBorderWidth = _this$props.defaultBorderWidth;
      return {
        step: {
          width: "".concat(width, "%"),
          display: 'table-cell',
          position: 'relative',
          paddingTop: circleTop
        },
        circle: {
          width: size,
          height: size,
          margin: '0 auto',
          backgroundColor: defaultColor,
          borderRadius: '50%',
          textAlign: 'center',
          padding: 1,
          fontSize: circleFontSize,
          color: circleFontColor,
          display: 'block',
          opacity: defaultOpacity,
          borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
          borderColor: defaultBorderColor,
          borderStyle: defaultBorderStyle
        },
        activeCircle: {
          backgroundColor: activeColor,
          opacity: activeOpacity,
          borderWidth: activeBorderColor ? defaultBorderWidth : 0,
          borderColor: activeBorderColor,
          borderStyle: activeBorderStyle
        },
        completedCircle: {
          backgroundColor: completeColor,
          opacity: completeOpacity,
          borderWidth: completeBorderColor ? defaultBorderWidth : 0,
          borderColor: completeBorderColor,
          borderStyle: completeBorderStyle
        },
        index: {
          lineHeight: "".concat(size + 0 / 4, "px"),
          color: 'black',
          fontWeight: '700'
        },
        indexActive: {
          lineHeight: "".concat(size + 0 / 4, "px"),
          color: 'white',
          fontWeight: '700'
        },
        title: {
          marginTop: titleTop,
          fontSize: titleFontSize,
          fontWeight: '700',
          textAlign: 'center',
          display: 'block',
          color: completeTitleColor,
          opacity: completeTitleOpacity
        },
        activeTitle: {
          color: completeTitleColor,
          opacity: completeTitleOpacity
        },
        completedTitle: {
          color: completeTitleColor,
          opacity: completeTitleOpacity
        },
        leftBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: defaultBarColor,
          left: 0,
          right: '50%',
          marginRight: size / 2 + lineMarginOffset,
          opacity: defaultOpacity
        },
        rightBar: {
          position: 'absolute',
          top: circleTop + size / 2,
          height: 1,
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: defaultBarColor,
          right: 0,
          left: '50%',
          marginLeft: size / 2 + lineMarginOffset,
          opacity: defaultOpacity
        },
        completedBar: {
          borderTopStyle: barStyle,
          borderTopWidth: 1,
          borderTopColor: completeBarColor,
          opacity: completeOpacity
        },
        check: {
          lineHeight: "".concat(size - 0 / 4, "px"),
          display: 'inline-block',
          transform: 'rotate(45deg)',
          height: '14px',
          width: '7px',
          marginTop: 6,
          marginBottom: 3,
          borderBottom: '3px solid white',
          borderRight: '3px solid white'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        icon = _this$props2.icon,
        index = _this$props2.index,
        active = _this$props2.active,
        completed = _this$props2.completed,
        first = _this$props2.first,
        isLast = _this$props2.isLast,
        href = _this$props2.href,
        onClick = _this$props2.onClick;
      var styles = this.getStyles();
      var circleStyle = Object.assign(styles.circle, completed ? styles.completedCircle : {}, active ? styles.activeCircle : {});
      var titleStyle = Object.assign(styles.title, completed ? styles.completedTitle : {}, active ? styles.activeTitle : {});
      var leftStyle = Object.assign(styles.leftBar, active || completed ? styles.completedBar : {});
      var rightStyle = Object.assign(styles.rightBar, completed ? styles.completedBar : {});
      var stepContent = icon ? /*#__PURE__*/React.createElement("img", {
        src: icon,
        alt: index + 1
      }) : index + 1;
      return /*#__PURE__*/React.createElement("div", {
        style: styles.step
      }, /*#__PURE__*/React.createElement("div", {
        style: circleStyle,
        onClick: onClick
      }, completed && /*#__PURE__*/React.createElement("div", {
        style: styles.check
      }), active && /*#__PURE__*/React.createElement("div", {
        style: styles.indexActive
      }, stepContent), !completed && !active && /*#__PURE__*/React.createElement("div", {
        style: styles.index
      }, stepContent)), active || completed ? /*#__PURE__*/React.createElement("a", {
        href: href,
        onClick: onClick,
        style: titleStyle
      }, title) : /*#__PURE__*/React.createElement("div", {
        style: titleStyle,
        onClick: onClick
      }, title), !first && /*#__PURE__*/React.createElement("div", {
        style: leftStyle
      }), !isLast && /*#__PURE__*/React.createElement("div", {
        style: rightStyle
      }));
    }
  }]);
  return Step;
}(Component);
Step.defaultProps = {
  activeColor: '#5096FF',
  completeColor: '#5096FF',
  defaultColor: '#E0E0E0',
  activeTitleColor: '#000',
  completeTitleColor: '#000',
  defaultTitleColor: '#757575',
  circleFontColor: '#FFF',
  size: 32,
  circleFontSize: 16,
  titleFontSize: 16,
  circleTop: 24,
  titleTop: 8,
  defaultBarColor: '#E0E0E0',
  barStyle: 'solid',
  borderStyle: 'solid',
  lineMarginOffset: 4,
  defaultBorderWidth: 3
};
Step.propTypes = {
  width: PropTypes.number.isRequired,
  activeColor: PropTypes.string,
  completeColor: PropTypes.string,
  defaultColor: PropTypes.string,
  activeTitleColor: PropTypes.string,
  completeTitleColor: PropTypes.string,
  defaultTitleColor: PropTypes.string,
  circleFontColor: PropTypes.string,
  size: PropTypes.number,
  circleFontSize: PropTypes.number,
  titleFontSize: PropTypes.number,
  circleTop: PropTypes.number,
  titleTop: PropTypes.number,
  title: PropTypes.string,
  index: PropTypes.number,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  first: PropTypes.bool,
  isLast: PropTypes.bool,
  completeOpacity: PropTypes.string,
  activeOpacity: PropTypes.string,
  defaultOpacity: PropTypes.string,
  completeTitleOpacity: PropTypes.string,
  activeTitleOpacity: PropTypes.string,
  defaultTitleOpacity: PropTypes.string,
  barStyle: PropTypes.string,
  defaultBarColor: PropTypes.string,
  completeBarColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  completeBorderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  defaultBorderStyle: PropTypes.string,
  completeBorderStyle: PropTypes.string,
  activeBorderStyle: PropTypes.string,
  lineMarginOffset: PropTypes.number,
  defaultBorderWidth: PropTypes.number
};

var styles = {
  root: {
    width: '100%',
    minHeight: 0,
    padding: 0
  },
  stepper: {
    display: 'table',
    width: '100%',
    margin: '0 auto'
  }
};
function Stepper(_ref) {
  var activeStep = _ref.activeStep,
    steps = _ref.steps,
    disabledSteps = _ref.disabledSteps,
    activeColor = _ref.activeColor,
    completeColor = _ref.completeColor,
    defaultColor = _ref.defaultColor,
    circleFontColor = _ref.circleFontColor,
    activeTitleColor = _ref.activeTitleColor,
    completeTitleColor = _ref.completeTitleColor,
    defaultTitleColor = _ref.defaultTitleColor,
    size = _ref.size,
    circleFontSize = _ref.circleFontSize,
    titleFontSize = _ref.titleFontSize,
    circleTop = _ref.circleTop,
    titleTop = _ref.titleTop,
    completeOpacity = _ref.completeOpacity,
    activeOpacity = _ref.activeOpacity,
    defaultOpacity = _ref.defaultOpacity,
    completeTitleOpacity = _ref.completeTitleOpacity,
    activeTitleOpacity = _ref.activeTitleOpacity,
    defaultTitleOpacity = _ref.defaultTitleOpacity,
    barStyle = _ref.barStyle,
    defaultBorderColor = _ref.defaultBorderColor,
    completeBorderColor = _ref.completeBorderColor,
    activeBorderColor = _ref.activeBorderColor,
    defaultBorderStyle = _ref.defaultBorderStyle,
    completeBorderStyle = _ref.completeBorderStyle,
    activeBorderStyle = _ref.activeBorderStyle,
    defaultBarColor = _ref.defaultBarColor,
    completeBarColor = _ref.completeBarColor,
    lineMarginOffset = _ref.lineMarginOffset,
    defaultBorderWidth = _ref.defaultBorderWidth;
  return /*#__PURE__*/React.createElement("div", {
    style: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.stepper
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index,
      width: 100 / steps.length,
      title: step.title,
      icon: step.icon,
      href: step.href,
      onClick: step.onClick,
      active: !(disabledSteps || []).includes(index) && index === activeStep,
      completed: !(disabledSteps || []).includes(index) && index < activeStep,
      first: index === 0,
      isLast: index === steps.length - 1,
      index: index,
      activeColor: activeColor,
      completeColor: completeColor,
      defaultColor: defaultColor,
      circleFontColor: circleFontColor,
      activeTitleColor: activeTitleColor,
      completeTitleColor: completeTitleColor,
      defaultTitleColor: defaultTitleColor,
      size: size,
      circleFontSize: circleFontSize,
      titleFontSize: titleFontSize,
      circleTop: circleTop,
      titleTop: titleTop,
      defaultOpacity: defaultOpacity,
      completeOpacity: completeOpacity,
      activeOpacity: activeOpacity,
      defaultTitleOpacity: defaultTitleOpacity,
      completeTitleOpacity: completeTitleOpacity,
      activeTitleOpacity: activeTitleOpacity,
      barStyle: barStyle,
      defaultBorderColor: defaultBorderColor,
      completeBorderColor: completeBorderColor,
      activeBorderColor: activeBorderColor,
      defaultBorderStyle: defaultBorderStyle,
      defaultBorderWidth: defaultBorderWidth,
      completeBorderStyle: completeBorderStyle,
      activeBorderStyle: activeBorderStyle,
      defaultBarColor: defaultBarColor,
      completeBarColor: completeBarColor,
      lineMarginOffset: lineMarginOffset
    });
  })));
}
Stepper.defaultProps = {
  activeStep: 0
};
Stepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array,
  activeColor: PropTypes.string,
  completeColor: PropTypes.string,
  defaultColor: PropTypes.string,
  activeTitleColor: PropTypes.string,
  completeTitleColor: PropTypes.string,
  defaultTitleColor: PropTypes.string,
  circleFontColor: PropTypes.string,
  size: PropTypes.number,
  circleFontSize: PropTypes.number,
  titleFontSize: PropTypes.number,
  circleTop: PropTypes.number,
  titleTop: PropTypes.number,
  defaultOpacity: PropTypes.string,
  completeOpacity: PropTypes.string,
  activeOpacity: PropTypes.string,
  defaultTitleOpacity: PropTypes.string,
  completeTitleOpacity: PropTypes.string,
  activeTitleOpacity: PropTypes.string,
  barStyle: PropTypes.string,
  defaultBarColor: PropTypes.string,
  completeBarColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  completeBorderColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  defaultBorderStyle: PropTypes.string,
  completeBorderStyle: PropTypes.string,
  activeBorderStyle: PropTypes.string,
  lineMarginOffset: PropTypes.number,
  defaultBorderWidth: PropTypes.number
};

function Spinner(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            .jcom-overlay{\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 10;\n              background: rgba(0,0,0,.5);\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              top: 0;\n              left: 0;\n            }\n      \n            .jcom-loader {\n              border: ".concat(props.thickness ? props.thickness : "10px", " solid rgba(255,255,255,0.3);\n              border-radius: 50%;\n              border-top: 10px solid white;\n              width: ").concat(props.size ? props.size : "100px", ";\n              height: ").concat(props.size ? props.size : "100px", ";\n              -webkit-animation: spin 1s linear infinite;\n              animation: spin 1s linear infinite;\n            }\n            \n            @-webkit-keyframes spin {\n              0% { -webkit-transform: rotate(0deg); }\n              100% { -webkit-transform: rotate(360deg); }\n            }\n            \n            @keyframes spin {\n              0% { transform: rotate(0deg); }\n              100% { transform: rotate(360deg); }\n            }\n        ")), /*#__PURE__*/React.createElement("div", {
    className: "jcom-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jcom-loader"
  })));
}

var SvgRef = function SvgRef(renderFn) {
  var ref = React.useRef();
  useEffect(function () {
    renderFn(d3.select(ref.current));
  });
  return ref;
};

function svgImage(_ref) {
  var imgData = _ref.imgData,
    style = _ref.style,
    zoomImage = _ref.zoomImage,
    id = _ref.id,
    viewBox = _ref.viewBox;
  var ref = SvgRef(function (svg) {
    if (svg) {
      svg.select("rect").style("opacity", "1");
      viewBox && svg.select("svg").attr("viewBox", viewBox);
      if (zoomImage) {
        d3.select("#imgId".concat(id)).on("mousemove", function (d) {
          var el = document.getElementById("imgId".concat(id));
          var parentRect = el.getBoundingClientRect();
          var stole = d3.select("svg").node();
          var stoleRect = stole.getBoundingClientRect();
          var ratio = stoleRect.height / stoleRect.width;
          var y = (d.y - parentRect.top) * -1 * ratio;
          // debugger;
          if (y * -1 + 500 > stoleRect.height) {
            y = (stoleRect.height - 450) * -1;
          }
          // console.log("d.y:::",d.y,"parentRect.height:::",parentRect.height,"Y:::",y,"stoleRect.height:::",stoleRect.height);
          d3.select("svg").attr("transform", "translate(-" + 0 + "," + y + ")");
        });
      } else {
        d3.select("#imgId".concat(id)).on('mousemove', null);
        d3.select('svg').attr('transform', null);
      }
    }
    svgData = svg;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, imgData && /*#__PURE__*/React.createElement("div", {
    id: "imgId" + id,
    style: style,
    dangerouslySetInnerHTML: {
      __html: imgData
    },
    ref: ref
  }));
}
var svgData = null;

// Color zone
function ColorComponent(_ref) {
  var pathId = _ref.pathId,
    colorCode = _ref.colorCode,
    id = _ref.id;
  if (svgData) {
    d3.select("#imgId".concat(id)).select("svg").select("g").select("#".concat(pathId)).style("fill", colorCode);
    return svgData;
  }
  return true;
}

// Image rendering zone
function ImageComponent(_ref) {
  var imgPath = _ref.imgPath,
    x = _ref.x,
    y = _ref.y,
    imgWidth = _ref.imgWidth,
    imgHeight = _ref.imgHeight,
    zone = _ref.zone,
    id = _ref.id,
    isPatch = _ref.isPatch;
  if (svgData) {
    d3.selectAll(".jcom-asset-zone".concat(id, "[pos=\"").concat(zone, "\"]")).remove();
    if (imgPath) {
      if (isPatch === 'y' || isPatch === 'Y') {
        d3.select("#imgId".concat(id)).select('svg').select('g').append('image').attr('xlink:href', imgPath).attr('x', x).attr('y', y).attr('class', "jcom-asset-zone".concat(id)).attr('pos', zone);
      } else {
        d3.select("#imgId".concat(id)).select('svg').select('g').append('image').attr('xlink:href', imgPath).attr('x', x).attr('y', y).style('width', imgWidth).style('height', imgHeight).attr('class', "jcom-asset-zone".concat(id)).attr('pos', zone);
      }
      return svgData;
    }
  }
  return true;
}

// Text rendering zone
function TextComponent(_ref) {
  var text = _ref.text,
    x = _ref.x,
    y = _ref.y,
    colorCode = _ref.colorCode,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? null : _ref$orientation,
    zone = _ref.zone,
    id = _ref.id,
    area = _ref.area;
  var position = text !== null && text !== void 0 && text.length ? (text === null || text === void 0 ? void 0 : text.length) === 1 ? 10 : (text === null || text === void 0 ? void 0 : text.length) === 2 ? -10 : -30 : 0;
  if (svgData) {
    d3.selectAll(".jcom-asset-zone".concat(id, "[pos=\"").concat(zone, "\"]")).remove();
    (text === null || text === void 0 ? void 0 : text.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, orientation === "text-v" ? text.map(function (data, index) {
      return d3.select("#imgId".concat(id)).select("svg").select("g").append("text").attr("text-anchor", "middle").attr("x", x + ((index + 1) * 80 + position)).attr("y", y + area / 2).style("font-size", "80px").style("fill", colorCode).style("writing-mode", "vertical-rl").style("text-orientation", "upright").attr("pos", zone).attr("class", "jcom-asset-zone".concat(id, " vertical-text")).style("letter-spacing", "-25px").text(data);
    }) : text.map(function (data, index) {
      return d3.select("#imgId".concat(id)).select("svg").select("g").append("text").attr("text-anchor", "middle").attr("x", x + area / 2).attr("y", y + ((index + 1) * 80 + 10)).style("font-size", "80px").style("fill", colorCode).attr("pos", zone).attr("class", "jcom-asset-zone".concat(id)).text(data);
    }));
    return svgData;
  }
  return true;
}

// Tip Image rendering zone
function TipComponent(_ref) {
  var imgPath = _ref.imgPath,
    imgWidth = _ref.imgWidth,
    imgHeight = _ref.imgHeight,
    zone = _ref.zone,
    id = _ref.id;
  if (svgData) {
    if (imgPath) {
      getImageSize(imgPath).then(function (img) {
        var height = img.height;
        var width = img.width;
        var rect = document.getElementsByClassName('st1')[0];
        var rectHeight = '';
        var rectWidth = '';
        var factor = '';
        if (rect) {
          rectHeight = rect.getAttribute('height');
          rectWidth = rect.getAttribute('width');
        }
        if (height > width) {
          factor = rectHeight / height;
        } else {
          factor = rectWidth / width;
        }
        height = height * factor;
        width = width * factor;
        if (height > rectHeight || width > rectWidth) {
          if (height > width) {
            factor = rectWidth / width;
          } else {
            factor = rectHeight / height;
          }
          height = height * factor;
          width = width * factor;
        }
        addTip(imgPath, width, height, zone, id);
      });
    } else {
      addTip(imgPath, imgWidth, imgHeight, zone, id);
    }
    return svgData;
  }
  return true;
}
function getImageSize(src) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      return resolve(img);
    };
    img.onerror = reject;
    img.src = src;
  });
}
function addTip(imgPath, imgWidth, imgHeight, zone, id) {
  d3.selectAll(".tipImageClass[pos=\"".concat(zone, "\"]")).remove();
  var rect = document.getElementsByClassName('st1')[0];
  var recX = '';
  var recY = '';
  if (rect) {
    recX = rect.getAttribute('x');
    recY = rect.getAttribute('y');
  }
  var defs = d3.select("#imgId".concat(id)).select('svg').select('g').select('#Tips_1_').select('defs');
  defs.append('pattern').attr('class', 'tipImageClass').attr('pos', zone).attr('id', 'tipPic').attr('patternUnits', 'userSpaceOnUse').attr('width', imgWidth).attr('height', imgHeight).attr('x', recX).attr('y', recY).append('svg:image').attr('xlink:href', imgPath).attr('width', imgWidth).attr('height', imgHeight);
  d3.select("#imgId".concat(id)).select('svg').select('g').select('rect').style('fill', 'url(#tipPic)');
}

function ZoneNameComponent(_ref) {
  var zoneNames = _ref.zoneNames,
    id = _ref.id;
  function wrap(text, width, content) {
    text.each(function () {
      var text = d3.select(this),
        words = content.split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1,
        x = text.attr('x'),
        y = text.attr('y'),
        dy = 0,
        tspan = text.text(null).attr('x', x).attr('y', y).attr('dy', dy + 'em');
      word = words.pop();
      while (word) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(' '));
          line = [word];
          tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
        }
        word = words.pop();
      }
    });
  }
  if (svgData) {
    d3.selectAll(".jcom-name-zone".concat(id)).remove();
    /*#__PURE__*/React.createElement(React.Fragment, null, zoneNames && zoneNames.map(function (data) {
      return d3.select("#imgId".concat(id)).select('g').append('text').attr('x', data.x).attr('y', data.y).attr("text-anchor", data.align).style('font-size', 70).text(data.name).attr('dy', '0em').style('stroke', 'black').attr("class", "jcom-name-zone".concat(id)).call(wrap, 30, data.name);
    }));
    return svgData;
  }
  return true;
}

function ZoneHighLightComponent(_ref) {
  var zoneNames = _ref.zoneNames,
    id = _ref.id;
  if (svgData) {
    d3.selectAll(".jcom-zone".concat(id)).remove();
    /*#__PURE__*/React.createElement(React.Fragment, null, zoneNames && zoneNames.map(function (data) {
      return d3.select("#imgId".concat(id)).select("svg").select("g").append("rect").attr("x", data.x).attr("y", data.y).style("width", data.width).style("height", data.height).style("stroke", "rgba(255,255,255,0.79)").style("stroke-width", "2").style("stroke-dasharray", "20,5").style("fill", "rgba(216,216,216,0.05)").attr("class", "jcom-zone".concat(id));
    }));
    return svgData;
  }
  return true;
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  svgImage: svgImage,
  addColor: ColorComponent,
  addImage: ImageComponent,
  addText: TextComponent,
  addTip: TipComponent,
  ZoneNameComponent: ZoneNameComponent,
  ZoneHighLightComponent: ZoneHighLightComponent
});

export { Container, index as ImageBuilder, Spinner, Stepper };
